// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"0182e44a","547":"63670897"}[chunkId] + ".chunk.js";
};